<docs>
# Icon

> NOTE: this docs defined at **docs** section inside Icon.vue module

Icon UI Set


<!-- STORY -->

### Channel Icon Example
naver, facebook, instagram, google, daum 은 default와 disable옵션이 있습니다.
>default
```html
<i class="mt-channel-icon mt-channel-icon--naver"></i>
```

>disable
```html
<i class="mt-channel-icon mt-channel-icon--naver-disable"></i>
```

### Channel Icon White Example
naver, facebook, instagram, google, daum 은 default와 disable옵션이 있습니다.
>default
```html
<i class="mt-channel-icon mt-channel-icon--naver_logo_white"></i>
```

### Channel Icon Initial Example

>Initial small
```html
<i class="mt-channel-icon mt-channel-icon--naver-initial"></i>
```

>Initial default
```html
<i class="mt-channel-icon mt-channel-icon--naver-initial"></i>
```

>Initial disable
```html
<i class="mt-channel-icon mt-channel-icon--naver-initial-disable"></i>
```

>Initial large
```html
<i class="mt-channel-icon mt-channel-icon--naver-initial"></i>
```

### Normal Icons

>default

```html
<mt-icon iconName="dashboard" />
```

>fixed hover status

```html
<mt icon iconName="dashboard" :hover="false" />
```

>loading spin by 'ease' animation-timing-function

```html
<mt icon iconName="loading" :hover="false" class="ease" />
```

#### Props

| Property | Description         | Type    | Accepted Values | Default     |
|----------|---------------------|---------|-----------------|-------------|
| color    | color               | String  | HEX Code        | #485465     |
| iconName | icon name           | String  | 'icon-name'     | dashboard   |
| width    | px of width         | Number  | —               | 14          |
| hover    | fixing hover status | Boolean | true/false      | false       |

</docs>

<template>
  <div class="mt-icon" @click="handleClick" v-on:mouseover="isHover = true" v-on:mouseleave="isHover = false" :class="classes">

    <template v-if="iconName === 'dashboard'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-120.000000, -370.000000)">
              <g id="dashboard" transform="translate(120.000000, 370.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(5.000000, 5.000000)" :fill="iconColor">
                      <rect id="Rectangle-3" x="0" y="0" width="6.53333333" height="6.53333333"></rect>
                      <rect id="Rectangle-3-Copy-2" x="0" y="7.46666667" width="6.53333333" height="6.53333333"></rect>
                      <rect id="Rectangle-3-Copy" x="7.46666667" y="0" width="6.53333333" height="6.53333333"></rect>
                      <rect id="Rectangle-3-Copy-3" x="7.46666667" y="7.46666667" width="6.53333333" height="6.53333333"></rect>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'reports'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
        <g fill="none" fill-rule="evenodd">
          <path stroke="#FFF" stroke-opacity=".01" d="M.5.5h23v23H.5z" style="mix-blend-mode:multiply"/>
          <g :fill="iconColor">
              <path d="M6 4h6.475v6.693h6.628v9.41H6z"/>
              <path d="M13.875 9.37v-5.3l5.181 5.3z"/>
          </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-bar-thick'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-388.000000, -370.000000)">
              <g id="graph-bar-thick" transform="translate(388.000000, 370.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(12.000000, 12.500000) scale(-1, 1) translate(-12.000000, -12.500000) translate(5.000000, 5.000000)" :fill="iconColor">
                      <rect id="Rectangle-8" x="7.57142857" y="4.28571429" width="6.42857143" height="10.7015202"></rect>
                      <rect id="Rectangle-8-Copy-2" x="0" y="0" width="6.42857143" height="14.9872345"></rect>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-line-thick'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-257.000000, -375.000000)">
              <g id="graph-line-thick" transform="translate(257.000000, 375.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <path d="M21,17.8333333 L4.125,17.8333333 L4.125,5 L3,5 L3,19 L21,19 L21,17.8333333 Z M17.625,8.5 L14.25,11.4166667 L9.1875,6.16666667 L5.25,11.4166667 L5.25,16.6666667 L19.875,16.6666667 L17.625,8.5 Z" :fill="iconColor"></path>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-bar-thin'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-790.000000, -370.000000)">
              <g id="graph-bar-thin" transform="translate(790.000000, 370.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" :stroke="iconColor" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="3 5 3 19 21 19 21 17.833 18.766 17.833 18.766 8.809 15.766 8.809 15.766 17.833 13.882 17.833 13.882 5.559 10.882 5.559 10.882 17.833 8.999 17.833 8.999 10.366 5.999 10.366 5.999 17.833 4.125 17.833 4.125 5"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-line-thin'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-656.000000, -370.000000)">
              <g id="graph-line-thin" transform="translate(656.000000, 370.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="3 5 3 19 21 19 21 17.833 4.839 17.833 7.502 12.538 10.838 13.975 14.033 7.374 16.923 10.891 20.784 6.714 19.903 5.9 16.976 9.065 13.769 5.164 10.258 12.419 6.938 10.989 4.125 16.581 4.125 5"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-scatter-thin'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-924.000000, -370.000000)">
              <g id="graph-scatter-thin" transform="translate(924.000000, 370.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(3.000000, 5.000000)" :fill="iconColor">
                      <polygon id="Fill-1" points="0 -0.0004 0 13.9996 18 13.9996 18 12.8326 1.125 12.8326 1.125 -0.0004"></polygon>
                      <g id="Group-12" transform="translate(3.000000, 1.000000)">
                          <path d="M2.541,10.2217 C3.802,10.2217 4.822,9.2007 4.822,7.9397 C4.822,6.6787 3.802,5.6577 2.541,5.6577 C1.28,5.6577 0.259,6.6787 0.259,7.9397 C0.259,9.2007 1.28,10.2217 2.541,10.2217" id="Fill-2"></path>
                          <path d="M6.4453,6.1025 C6.4453,6.9675 7.1443,7.6685 8.0093,7.6685 C8.8753,7.6685 9.5743,6.9675 9.5743,6.1025 C9.5743,5.2395 8.8753,4.5385 8.0093,4.5385 C7.1443,4.5385 6.4453,5.2395 6.4453,6.1025" id="Fill-4"></path>
                          <path d="M7.3066,2.8086 C8.0286,2.8086 8.6136,2.2236 8.6136,1.5026 C8.6136,0.7806 8.0286,0.1946 7.3066,0.1946 C6.5836,0.1946 5.9996,0.7806 5.9996,1.5026 C5.9996,2.2236 6.5836,2.8086 7.3066,2.8086" id="Fill-6"></path>
                          <path d="M11.3604,3.6738 C11.8364,3.6738 12.2234,3.2868 12.2234,2.8088 C12.2234,2.3298 11.8364,1.9438 11.3604,1.9438 C10.8824,1.9438 10.4954,2.3298 10.4954,2.8088 C10.4954,3.2868 10.8824,3.6738 11.3604,3.6738" id="Fill-8"></path>
                          <path d="M3.9121,4.5381 C4.4961,4.5381 4.9701,4.0631 4.9701,3.4781 C4.9701,2.8931 4.4961,2.4201 3.9121,2.4201 C3.3271,2.4201 2.8531,2.8931 2.8531,3.4781 C2.8531,4.0631 3.3271,4.5381 3.9121,4.5381" id="Fill-10"></path>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-sm-bar-thin'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-120.000000, -559.000000)">
              <g id="graph-sm-bar-thin" transform="translate(120.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="3 5 3 10.682 3 11.849 3 19 5.9988334 19 8.99866674 19 10.8815621 19 13.8813955 19 15.7652908 19 18.7651242 19 21 19 21 17.833 18.7651242 17.833 18.7651242 14.757 15.7652908 14.757 15.7652908 17.833 13.8813955 17.833 13.8813955 13.389 10.8815621 13.389 10.8815621 17.833 8.99866674 17.833 8.99866674 15.129 5.9988334 15.129 5.9988334 17.833 4.12593745 17.833 4.12593745 11.849 5.9988334 11.849 8.99866674 11.849 10.8815621 11.849 13.8813955 11.849 15.7652908 11.849 18.7651242 11.849 21 11.849 21 10.682 18.7651242 10.682 18.7651242 7.605 15.7652908 7.605 15.7652908 10.682 13.8813955 10.682 13.8813955 6.238 10.8815621 6.238 10.8815621 10.682 8.99866674 10.682 8.99866674 7.976 5.9988334 7.976 5.9988334 10.682 4.12593745 10.682 4.12593745 5"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'graph-sm-line-thin'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1058.000000, -370.000000)">
              <g id="graph-sm-line-thin" transform="translate(1058.000000, 370.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="3 5 3 10.682 3 11.849 3 19 21 19 21 17.833 5.318 17.833 10.679 14.791 15.175 16.692 20.146 14.366 19.622 13.246 15.149 15.338 10.599 13.414 4.125 17.087 4.125 11.849 21 11.849 21 10.682 5.344 10.682 10.654 7.669 15.149 9.568 20.12 7.244 19.597 6.122 15.124 8.215 10.574 6.292 4.125 9.951 4.125 5"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'chevron-left'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-254.000000, -559.000000)">
              <g id="chevron-left" transform="translate(254.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="14.6476987 5 8 12.0015107 14.6476987 19 16 17.5759298 10.7065152 12.0015107 16 6.42507733"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'chevron-right'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-388.000000, -559.000000)">
              <g id="chevron-right" transform="translate(388.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="9.35230126 5 8 6.42507733 13.2944411 11.9994964 8 17.5759298 9.35230126 19 16 11.9994964"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'chevron-up'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-522.000000, -559.000000)">
              <g id="chevron-up" transform="translate(522.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="11.998993 8 5 14.6475371 6.42497482 16 11.998993 10.7058824 17.5750252 16 19 14.6475371"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'chevron-down'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
         <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-656.000000, -559.000000)">
              <g id="chevron-down" transform="translate(656.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="17.5750252 8 12.001007 13.2944411 6.42497482 8 5 9.35325762 12.001007 16 19 9.35325762"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'plus'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-790.000000, -559.000000)">
              <g id="plus" transform="translate(790.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="11 4 11 11 4 11 4 13 11 13 11 20 13 20 13 13 20 13 20 11 13 11 13 4"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'minus'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-924.000000, -559.000000)">
              <g id="minus" transform="translate(924.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="4 13 20 13 20 11 4 11"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'loading'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-120.000000, -937.000000)">
              <g id="loading" transform="translate(120.000000, 937.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <path d="M4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C11.6601325,4 11.3846154,4.27551708 11.3846154,4.61538462 C11.3846154,4.95525215 11.6601325,5.23076923 12,5.23076923 C15.7385429,5.23076923 18.7692308,8.26145708 18.7692308,12 C18.7692308,15.7385429 15.7385429,18.7692308 12,18.7692308 C8.26145708,18.7692308 5.23076923,15.7385429 5.23076923,12 C5.23076923,11.6601325 4.95525215,11.3846154 4.61538462,11.3846154 C4.27551708,11.3846154 4,11.6601325 4,12 L4,12 Z" :fill="iconColor" fill-rule="nonzero"></path>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'loading2'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 100 100" >
          <g transform="translate(50,50)"><g ng-attr-transform="scale(config.scale)" transform="scale(0.7)"><g transform="translate(-50,-50)"><g transform="rotate(287.816 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="0.75s" begin="0s" repeatCount="indefinite"></animateTransform><path ng-attr-fill-opacity="config.opacity" ng-attr-fill="config.c1" d="M50 50L50 0A50 50 0 0 1 100 50Z" fill-opacity="0.8" fill="#5bc0de"></path></g><g transform="rotate(215.862 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform><path ng-attr-fill-opacity="config.opacity" ng-attr-fill="config.c2" d="M50 50L50 0A50 50 0 0 1 100 50Z" transform="rotate(90 50 50)" fill-opacity="0.8" fill="#5bb4de"></path></g><g transform="rotate(143.908 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1.5s" begin="0s" repeatCount="indefinite"></animateTransform><path ng-attr-fill-opacity="config.opacity" ng-attr-fill="config.c3" d="M50 50L50 0A50 50 0 0 1 100 50Z" transform="rotate(180 50 50)" fill-opacity="0.8" fill="#5b93de"></path></g><g transform="rotate(71.9539 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="3s" begin="0s" repeatCount="indefinite"></animateTransform><path ng-attr-fill-opacity="config.opacity" ng-attr-fill="config.c4" d="M50 50L50 0A50 50 0 0 1 100 50Z" transform="rotate(270 50 50)" fill-opacity="0.8" fill="#5b7fde"></path></g></g></g></g>
      </svg>
    </template>
    <template v-else-if="iconName === 'sync'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <defs>
              <polygon id="path-sync" points="0.7315 0.299 17.1125 0.299 17.1125 7.4248 0.7315 7.4248"></polygon>
          </defs>
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-388.000000, -937.000000)">
              <g id="sync" transform="translate(388.000000, 937.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(3.000000, 4.000000)">
                      <g id="Group-3" transform="translate(0.000000, 0.701200)">
                          <mask id="mask-sync" fill="white">
                              <use xlink:href="#path-sync"></use>
                          </mask>
                          <g id="Clip-2"></g>
                          <path d="M2.7065,7.4248 C3.0725,4.5178 5.5545,2.2588 8.5595,2.2588 C10.3575,2.2588 11.9605,3.0758 13.0455,4.3498 L11.0565,3.9368 L10.6595,5.8568 L16.0065,6.9648 L17.1125,1.6288 L15.1935,1.2318 L14.7565,3.3378 L14.7445,3.3458 C13.3045,1.4998 11.0755,0.2988 8.5595,0.2988 C4.4725,0.2988 1.1065,3.4348 0.7315,7.4248 L2.7065,7.4248 Z" id="Fill-1" :fill="iconColor" mask="url(#mask-sync)"></path>
                      </g>
                      <path d="M14.4062,9.5752 C14.0402,12.4822 11.5582,14.7412 8.5522,14.7412 C6.7552,14.7412 5.1522,13.9242 4.0672,12.6512 L6.0562,13.0632 L6.4532,11.1432 L1.1062,10.0352 L0.0002,15.3712 L1.9192,15.7692 L2.3562,13.6632 L2.3682,13.6552 C3.8082,15.5002 6.0372,16.7012 8.5522,16.7012 C12.6402,16.7012 16.0062,13.5662 16.3802,9.5752 L14.4062,9.5752 Z" id="Fill-4" :fill="iconColor"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'check'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-254.000000, -937.000000)">
              <g id="check" transform="translate(254.000000, 937.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="18.4830677 5 9.47808765 15.8566529 5.55776892 10.7034443 4 11.9499786 9.43326693 19 20 6.29555524"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'close-circle'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-522.000000, -937.000000)">
              <g id="close-circle" transform="translate(522.000000, 937.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <path d="M16.207,14.793 L14.793,16.207 L12,13.414 L9.208,16.207 L7.794,14.793 L10.586,12 L7.794,9.207 L9.208,7.793 L12,10.586 L14.793,7.793 L16.207,9.207 L13.414,12 L16.207,14.793 Z M12,4 C7.582,4 4,7.582 4,12 C4,16.42 7.582,20 12,20 C16.419,20 20,16.42 20,12 C20,7.582 16.419,4 12,4 Z" :fill="iconColor"></path>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'help-circle'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <defs>
              <polygon id="path-help-circle" points="0 0 15.9996 0 15.9996 15.9999 0 15.9999"></polygon>
          </defs>
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-656.000000, -937.000000)">
              <g id="help-circle" transform="translate(656.000000, 937.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 4.000000)">
                      <mask id="mask-help-circle" fill="white">
                          <use xlink:href="#path-help-circle"></use>
                      </mask>
                      <g id="Clip-2"></g>
                      <path d="M10.8066,7.3809 C10.6466,7.6099 10.3376,7.9019 9.8826,8.2579 L9.4326,8.6079 C9.1886,8.7969 9.0256,9.0199 8.9456,9.2739 C8.8946,9.4339 8.8676,9.6839 8.8636,10.0219 L7.1436,10.0219 C7.1676,9.3069 7.2366,8.8129 7.3456,8.5389 C7.4546,8.2679 7.7386,7.9529 8.1936,7.5979 L8.6556,7.2359 C8.8076,7.1209 8.9296,6.9959 9.0226,6.8609 C9.1916,6.6289 9.2766,6.3729 9.2766,6.0939 C9.2766,5.7719 9.1816,5.4789 8.9946,5.2129 C8.8066,4.9489 8.4626,4.8169 7.9646,4.8169 C7.4756,4.8169 7.1276,4.9809 6.9226,5.3069 C6.7186,5.6309 6.6166,5.9709 6.6166,6.3219 L4.7826,6.3219 C4.8326,5.1149 5.2536,4.2599 6.0446,3.7579 C6.5436,3.4359 7.1586,3.2759 7.8856,3.2759 C8.8416,3.2759 9.6366,3.5039 10.2696,3.9609 C10.9026,4.4179 11.2176,5.0939 11.2176,5.9919 C11.2176,6.5409 11.0806,7.0039 10.8066,7.3809 Z M7.0986,12.7269 L8.9966,12.7269 L8.9966,10.8929 L7.0986,10.8929 L7.0986,12.7269 Z M7.9996,-0.0001 C3.5816,-0.0001 -0.0004,3.5819 -0.0004,7.9999 C-0.0004,12.4199 3.5816,15.9999 7.9996,15.9999 C12.4186,15.9999 15.9996,12.4199 15.9996,7.9999 C15.9996,3.5819 12.4186,-0.0001 7.9996,-0.0001 Z" id="Fill-1" :fill="iconColor" mask="url(#mask-help-circle)"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'information-circle'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
        <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-790.000000, -937.000000)">
            <g id="information-circle" transform="translate(790.000000, 937.000000)">
                <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                <path d="M11.051,9.35 L12.949,9.35 L12.949,7.516 L11.051,7.516 L11.051,9.35 Z M11.051,16.486 L12.949,16.486 L12.949,10.402 L11.051,10.402 L11.051,16.486 Z M12,4 C7.582,4 4,7.582 4,12 C4,16.42 7.582,20 12,20 C16.418,20 20,16.42 20,12 C20,7.582 16.418,4 12,4 Z" :fill="iconColor"></path>
            </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'warning-circle'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
        <defs>
              <polygon id="path-warning-circle" points="0 0.0003 16.5467 0.0003 16.5467 16.5381 0 16.5381"></polygon>
          </defs>
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1058.000000, -937.000000)">
              <g id="warning-circle" transform="translate(1058.000000, 937.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 4.000000)">
                      <mask id="mask-warning-circle" fill="white">
                          <use xlink:href="#path-warning-circle"></use>
                      </mask>
                      <g id="Clip-2"></g>
                      <path d="M9.2227,11.8223 L7.3247,11.8223 L7.0247,5.7383 L9.5227,5.7383 L9.2227,11.8223 Z M7.3247,14.7093 L9.2227,14.7093 L9.2227,12.8753 L7.3247,12.8753 L7.3247,14.7093 Z M16.4647,15.5673 L16.4657,15.5653 L8.8607,0.3673 L8.8607,0.3693 C8.7537,0.1513 8.5327,0.0003 8.2737,0.0003 C8.0127,0.0003 7.7897,0.1523 7.6837,0.3713 L0.0787,15.5713 C0.0317,15.6643 -0.0003,15.7683 -0.0003,15.8803 C-0.0003,16.2433 0.2927,16.5383 0.6577,16.5383 L15.8887,16.5383 L15.8897,16.5383 C16.2537,16.5383 16.5467,16.2433 16.5467,15.8803 C16.5467,15.7663 16.5157,15.6613 16.4647,15.5673 Z" id="Fill-1" :fill="iconColor" mask="url(#mask-warning-circle)"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'error-circle'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
        <defs>
            <polygon id="path-error-circle" points="0.0002 0 16 0 16 15.9997 0.0002 15.9997"></polygon>
        </defs>
        <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-924.000000, -937.000000)">
            <g id="error-circle" transform="translate(924.000000, 937.000000)">
                <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                <g transform="translate(4.000000, 4.000000)">
                    <mask id="mask-error-circle" fill="white">
                        <use xlink:href="#path-error-circle"></use>
                    </mask>
                    <g id="Clip-2"></g>
                    <path d="M8.9492,9.5977 L7.0512,9.5977 L6.7512,3.5137 L9.2492,3.5137 L8.9492,9.5977 Z M7.0512,12.4847 L8.9492,12.4847 L8.9492,10.6507 L7.0512,10.6507 L7.0512,12.4847 Z M8.0002,-0.0003 C3.5822,-0.0003 0.0002,3.5797 0.0002,7.9997 C0.0002,12.4177 3.5822,15.9997 8.0002,15.9997 C12.4192,15.9997 16.0002,12.4177 16.0002,7.9997 C16.0002,3.5797 12.4192,-0.0003 8.0002,-0.0003 Z" id="Fill-1" :fill="iconColor" mask="url(#mask-error-circle)"></path>
                </g>
            </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'filter'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <defs>
              <polygon id="path-filter" points="0 0.0002 15.9608 0.0002 15.9608 16.1159 0 16.1159"></polygon>
          </defs>
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-120.000000, -748.000000)">
              <g id="filter" transform="translate(120.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 4.000000)">
                      <mask id="mask-filter" fill="white">
                          <use xlink:href="#path-filter"></use>
                      </mask>
                      <g id="Clip-2"></g>
                      <path d="M8.9888,6.7139 L8.9888,11.1589 L6.9008,12.4819 L6.9008,6.7179 L3.4408,1.9999 L12.4908,1.9999 L8.9888,6.7139 Z M15.9608,0.5299 C15.9608,0.2379 15.7248,0.0019 15.4328,0.0019 L15.4328,-0.0001 L0.5138,-0.0001 C0.2288,0.0079 -0.0002,0.2379 -0.0002,0.5259 C-0.0002,0.6389 0.0428,0.7369 0.1038,0.8229 L0.0998,0.8259 L4.9008,7.3719 L4.9008,16.1159 L10.9888,12.2589 L10.9888,7.3759 L15.8658,0.8119 C15.9208,0.7299 15.9608,0.6369 15.9608,0.5299 Z" id="Fill-1" :fill="iconColor" mask="url(#mask-filter)"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'download'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-254.000000, -748.000000)">
              <g id="download" transform="translate(254.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 5.000000)" :fill="iconColor">
                      <polygon id="Fill-1" points="14.0058 9.0587 14.0058 12.8917 1.9998 12.8917 1.9998 9.0587 -0.0002 9.0587 0.0048 14.8917 16.0048 14.8917 16.0058 9.0587"></polygon>
                      <polygon id="Fill-2" points="6.9723 0.0002 6.9723 7.3592 4.7733 5.1602 3.3593 6.5742 8.0073 11.2212 12.6463 6.5832 11.2323 5.1692 8.9733 7.4282 8.9733 0.0002"></polygon>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'upload'">
       <svg :width="iconWidth + 'px'" height="24" viewBox="0 0 24 24">
            <g fill="none" fill-rule="evenodd">
                <path stroke="#FFF" stroke-opacity=".01" d="M.5.5h23v23H.5z" style="mix-blend-mode:multiply"/>
                <g :fill="iconColor">
                    <path d="M18.006 14.059v3.833H6v-3.833H4l.005 5.833h16v-5.833z"/>
                    <path d="M13.033 16.221V8.862l2.2 2.2 1.413-1.415L11.998 5 7.36 9.638l1.414 1.414 2.26-2.259v7.428z"/>
                </g>
            </g>
        </svg>
    </template>
    <template v-else-if="iconName === 'more'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-388.000000, -748.000000)">
              <g id="more" transform="translate(388.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <path d="M12,8 C13.1,8 14,7.1 14,6 C14,4.9 13.1,4 12,4 C10.9,4 10,4.9 10,6 C10,7.1 10.9,8 12,8 L12,8 Z M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 L12,10 Z M12,16 C10.9,16 10,16.9 10,18 C10,19.1 10.9,20 12,20 C13.1,20 14,19.1 14,18 C14,16.9 13.1,16 12,16 L12,16 Z" :fill="iconColor"></path>
              </g>
          </g>
      </svg>
    </template>

    <template v-else-if="iconName === 'close'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1058.000000, -559.000000)">
              <g id="close" transform="translate(1058.000000, 559.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon :fill="iconColor" points="16.5557825 5 11.5 10.0553853 6.44421747 5 5 6.44410401 10.0557825 11.5005106 5 16.555896 6.44421747 18 11.5 12.9446147 16.5557825 18 18 16.555896 12.9442175 11.5005106 18 6.44410401"></polygon>
              </g>
          </g>
      </svg>
    </template>

    <template v-else-if="iconName === 'delete'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-522.000000, -748.000000)">
              <g id="delete" transform="translate(522.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 4.000000)" :fill="iconColor">
                      <path d="M5.319,-0.0001 L5.319,1.9909 L1.322,1.9909 L0,1.9909 L0,3.9909 L1.322,3.9909 L1.322,15.3469 L14.678,15.3469 L14.678,3.9909 L16,3.9909 L16,1.9909 L14.678,1.9909 L10.68,1.9909 L10.68,-0.0001 L5.319,-0.0001 Z M3.322,13.3469 L12.677,13.3469 L12.677,3.9909 L3.322,3.9909 L3.322,13.3469 Z" id="Fill-1"></path>
                      <polygon id="Fill-2" points="5.261 11.5387 7.261 11.5387 7.261 5.8617 5.261 5.8617"></polygon>
                      <polygon id="Fill-3" points="8.739 11.5387 10.739 11.5387 10.739 5.8617 8.739 5.8617"></polygon>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'search'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-656.000000, -748.000000)">
              <g id="search" transform="translate(656.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <path d="M15,10.5 C15,8.015 12.986,6 10.5,6 C8.016,6 6,8.015 6,10.5 C6,12.985 8.016,15 10.5,15 C12.986,15 15,12.985 15,10.5 M10.5,17 C6.91,17 4,14.09 4,10.5 C4,6.91 6.91,4 10.5,4 C14.09,4 17,6.91 17,10.5 C17,11.934 16.536,13.26 15.75,14.335 L19.735,18.32 C20.126,18.711 20.126,19.344 19.735,19.734 C19.345,20.125 18.711,20.125 18.321,19.734 L14.335,15.749 C13.26,16.535 11.935,17 10.5,17" id="Fill-1" :fill="iconColor"></path>
              </g>
          </g>
      </svg>
    </template>

    <template v-else-if="iconName === 'edit'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-790.000000, -748.000000)">
              <g id="edit" transform="translate(790.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <path d="M6.23319,15.4896145 L5,20 L9.49704284,18.7493836 L16.5993602,11.6564772 L13.2958062,8.43668647 L6.23319,15.4896145 L6.23319,15.4896145 Z M16.0606032,5.67503778 L14.291267,7.44227358 L17.6058426,10.6516922 L19.3238382,8.93532355 C20.2253873,8.03477643 20.2253873,6.57548555 19.3238382,5.67503778 C18.4224884,4.77498741 16.9609166,4.77498741 16.0606032,5.67503778 Z" :fill="iconColor"></path>
              </g>
          </g>
      </svg>
    </template>

    <template v-else-if="iconName === 'reset'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <defs>
              <polygon id="path-reset" points="0.0003 0.9995 16.417 0.9995 16.417 16.7285 0.0003 16.7285"></polygon>
          </defs>
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-924.000000, -748.000000)">
              <g id="reset" transform="translate(924.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 4.000000)">
                      <mask id="mask-reset" fill="white">
                          <use xlink:href="#path-reset"></use>
                      </mask>
                      <g id="Clip-2"></g>
                      <path d="M7.8643,14.7685 C4.6083,14.7685 1.9603,12.1205 1.9603,8.8645 C1.9603,5.6085 4.6083,2.9595 7.8643,2.9595 C9.6633,2.9595 11.2663,3.7775 12.3503,5.0495 L10.3613,4.6375 L9.9643,6.5575 L15.3113,7.6645 L16.4173,2.3305 L14.4993,1.9315 L14.0613,4.0385 L14.0493,4.0455 C12.6093,2.2015 10.3813,0.9995 7.8643,0.9995 C3.5283,0.9995 0.0003,4.5285 0.0003,8.8645 C0.0003,13.2015 3.5283,16.7285 7.8643,16.7285 C11.4663,16.7285 14.5033,14.2905 15.4313,10.9805 L13.5113,10.5845 C12.7733,13.0035 10.5213,14.7685 7.8643,14.7685" id="Fill-1" :fill="iconColor" mask="url(#mask-reset)"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>

    <template v-else-if="iconName === 'settings'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-522.000000, -370.000000)">
            <g id="settings" transform="translate(522.000000, 370.000000)">
                <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                <path d="M14.6666667,12 C14.6666667,13.46875 13.46875,14.6666667 12,14.6666667 C10.53125,14.6666667 9.33333333,13.46875 9.33333333,12 C9.33333333,10.53125 10.53125,9.33333333 12,9.33333333 C13.46875,9.33333333 14.6666667,10.53125 14.6666667,12 L14.6666667,12 Z M20,10.8645833 C20,10.6875 19.875,10.5208333 19.6979167,10.4895833 L17.7916667,10.1979167 C17.6875,9.85416667 17.5416667,9.51041667 17.3645833,9.17708333 C17.71875,8.6875 18.1041667,8.22916667 18.4583333,7.75 C18.5104167,7.67708333 18.5416667,7.60416667 18.5416667,7.51041667 C18.5416667,7.42708333 18.5208333,7.34375 18.46875,7.28125 C18.03125,6.66666667 17.3020833,6.02083333 16.75,5.51041667 C16.6770833,5.44791667 16.5833333,5.40625 16.4895833,5.40625 C16.3958333,5.40625 16.3020833,5.4375 16.2395833,5.5 L14.7604167,6.61458333 C14.4583333,6.45833333 14.1458333,6.33333333 13.8229167,6.22916667 L13.53125,4.3125 C13.5104167,4.13541667 13.34375,4 13.15625,4 L10.84375,4 C10.65625,4 10.5104167,4.125 10.46875,4.29166667 C10.3020833,4.91666667 10.2395833,5.59375 10.1666667,6.22916667 C9.84375,6.33333333 9.52083333,6.46875 9.21875,6.625 L7.78125,5.51041667 C7.69791667,5.44791667 7.60416667,5.40625 7.51041667,5.40625 C7.15625,5.40625 5.75,6.92708333 5.5,7.27083333 C5.44791667,7.34375 5.40625,7.41666667 5.40625,7.51041667 C5.40625,7.60416667 5.44791667,7.6875 5.51041667,7.76041667 C5.89583333,8.22916667 6.27083333,8.69791667 6.625,9.19791667 C6.45833333,9.51041667 6.32291667,9.82291667 6.21875,10.15625 L4.28125,10.4479167 C4.125,10.4791667 4,10.6666667 4,10.8229167 L4,13.1354167 C4,13.3125 4.125,13.4791667 4.30208333,13.5104167 L6.20833333,13.7916667 C6.3125,14.1458333 6.45833333,14.4895833 6.63541667,14.8229167 C6.28125,15.3125 5.89583333,15.7708333 5.54166667,16.25 C5.48958333,16.3229167 5.45833333,16.3958333 5.45833333,16.4895833 C5.45833333,16.5729167 5.47916667,16.65625 5.53125,16.7291667 C5.96875,17.3333333 6.69791667,17.9791667 7.25,18.4791667 C7.32291667,18.5520833 7.41666667,18.59375 7.51041667,18.59375 C7.60416667,18.59375 7.69791667,18.5625 7.77083333,18.5 L9.23958333,17.3854167 C9.54166667,17.5416667 9.85416667,17.6666667 10.1770833,17.7708333 L10.46875,19.6875 C10.4895833,19.8645833 10.65625,20 10.84375,20 L13.15625,20 C13.34375,20 13.4895833,19.875 13.53125,19.7083333 C13.6979167,19.0833333 13.7604167,18.40625 13.8333333,17.7708333 C14.15625,17.6666667 14.4791667,17.53125 14.78125,17.375 L16.21875,18.5 C16.3020833,18.5520833 16.3958333,18.59375 16.4895833,18.59375 C16.84375,18.59375 18.25,17.0625 18.5,16.7291667 C18.5625,16.65625 18.59375,16.5833333 18.59375,16.4895833 C18.59375,16.3958333 18.5520833,16.3020833 18.4895833,16.2291667 C18.1041667,15.7604167 17.7291667,15.3020833 17.375,14.7916667 C17.5416667,14.4895833 17.6666667,14.1770833 17.78125,13.84375 L19.7083333,13.5520833 C19.875,13.5208333 20,13.3333333 20,13.1770833 L20,10.8645833 Z" :fill="iconColor"></path>
            </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'eye'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1058.000000, -748.000000)">
              <g id="eye" transform="translate(1058.000000, 748.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(3.000000, 6.000000)" :fill="iconColor">
                      <path d="M9.50001137,10.718471 C6.99251229,10.718471 4.95979918,8.69167512 4.95979918,6.19157327 C4.95979918,3.69142761 6.99251229,1.66467557 9.50001137,1.66467557 C12.0074665,1.66467557 14.0402236,3.69142761 14.0402236,6.19157327 C14.0402236,8.69167512 12.0074665,10.718471 9.50001137,10.718471 M18.827495,5.39263939 C16.9754079,2.17075026 13.4927654,0 9.50119768,0 C5.50967391,0 2.02698747,2.17079407 0.174900409,5.39272701 C0.148230496,5.44560375 -0.177827866,6.11753706 0.134346324,6.71482085 C1.97584451,9.9759185 5.48036776,12.1787365 9.50119768,12.1787365 C13.5204898,12.1787365 17.0237828,9.97771465 18.8658961,6.71880742 C19.1766204,6.12695587 18.8535937,5.44560375 18.827495,5.39263939" id="Fill-1"></path>
                      <path d="M11.9555085,6.24961479 C11.9555085,7.59926549 10.8561217,8.69337442 9.5,8.69337442 C8.14384625,8.69337442 7.04449153,7.59926549 7.04449153,6.24961479 C7.04449153,4.89996409 8.14384625,3.80585516 9.5,3.80585516 C10.8561217,3.80585516 11.9555085,4.89996409 11.9555085,6.24961479" id="Fill-3"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'check-circle'">
       <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <defs>
              <polygon id="path-check-circle" points="0 0 15.9986 0 15.9986 16 0 16"></polygon>
          </defs>
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-121.000000, -1122.000000)">
              <g id="check-circle" transform="translate(121.000000, 1122.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <g transform="translate(4.000000, 4.000000)">
                      <mask id="mask-check-circle" fill="white">
                          <use xlink:href="#path-check-circle"></use>
                      </mask>
                      <g id="Clip-2"></g>
                      <path d="M6.8516,12.127 L3.3276,7.631 L4.8916,6.385 L6.8966,8.986 L11.1496,3.871 L12.6726,5.166 L6.8516,12.127 Z M7.9986,0 C3.5816,0 -0.0004,3.58 -0.0004,8 C-0.0004,12.418 3.5816,16 7.9986,16 C12.4186,16 15.9986,12.418 15.9986,8 C15.9986,3.58 12.4186,0 7.9986,0 Z" id="Fill-1" :fill="iconColor" mask="url(#mask-check-circle)"></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'pictogram-01'">
       <svg :width="iconWidth" viewBox="0 0 36 47">
          <g :fill="iconColor" fill-rule="evenodd">
                <path d="M16.844 44.771s.401.301.982.301c.368 0 .745-.12 1.12-.358l14.564-9.242c.252-.15.493-.41.494-.519 0-.035-.082-.218-.492-.476L19.46 25.629a2.675 2.675 0 0 0-1.378-.401c-.456 0-.9.135-1.318.4L2.897 34.411c-.362.152-.8.487-.817.692-.01.12.174.474.944.96l13.82 8.707zm.982 1.93a3.382 3.382 0 0 1-1.97-.632L2.151 37.44c-1.206-.76-1.778-1.594-1.7-2.48.106-1.208 1.395-1.865 1.752-2.025l13.683-8.682a4.053 4.053 0 0 1 2.196-.655c1.28 0 2.185.605 2.284.675l14.02 8.826c.845.532 1.267 1.166 1.253 1.885-.022 1.12-1.152 1.804-1.28 1.878l-14.535 9.224c-.641.408-1.314.614-1.998.614z"/>
                <path d="M16.844 33.273s.401.301.982.301c.368 0 .745-.12 1.12-.358l14.564-9.242c.252-.15.493-.41.494-.519 0-.035-.082-.218-.492-.476L19.46 14.13a2.675 2.675 0 0 0-1.378-.401c-.456 0-.9.135-1.318.4L2.897 22.914c-.362.151-.8.488-.817.692-.01.12.174.474.944.959l13.82 8.708zm.982 1.93a3.382 3.382 0 0 1-1.97-.633L2.151 25.943c-1.206-.76-1.778-1.594-1.7-2.48.106-1.208 1.395-1.865 1.752-2.025l13.683-8.682a4.048 4.048 0 0 1 2.196-.655c1.28 0 2.185.605 2.284.674l14.02 8.827c.845.532 1.267 1.166 1.253 1.885-.022 1.12-1.152 1.804-1.28 1.879l-14.535 9.223c-.641.408-1.314.614-1.998.614z"/>
                <path d="M16.844 21.775s.401.301.982.301c.368 0 .745-.12 1.12-.359l14.564-9.24c.252-.152.493-.41.494-.52 0-.035-.082-.219-.492-.476L19.46 2.633c-.031-.02-.607-.401-1.378-.401-.456 0-.9.134-1.318.4L2.897 11.416c-.362.151-.8.488-.817.692-.01.12.174.475.944.959l13.82 8.708zm.982 1.93a3.382 3.382 0 0 1-1.97-.633L2.151 14.445c-1.206-.76-1.778-1.595-1.7-2.48.106-1.207 1.395-1.865 1.752-2.025l13.683-8.682a4.047 4.047 0 0 1 2.196-.655c1.28 0 2.185.606 2.284.674l14.02 8.826c.845.533 1.267 1.167 1.253 1.885-.022 1.12-1.152 1.806-1.28 1.88L19.824 23.09c-.641.408-1.314.614-1.998.614z"/>
            </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'pictogram-02'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 40 39">
          <g :fill="iconColor" fill-rule="evenodd">
                <path d="M8.385 4.731c0-.463.374-.84.834-.84.461 0 .835.377.835.84a.837.837 0 0 1-.835.84.837.837 0 0 1-.834-.84zm-2.502 0c0-.463.374-.84.834-.84.46 0 .834.377.834.84a.837.837 0 0 1-.834.84.837.837 0 0 1-.834-.84zm-1.668.84a.838.838 0 0 1-.835-.84c0-.463.376-.84.835-.84.46 0 .834.377.834.84a.837.837 0 0 1-.834.84zM1.712 3.057c0-.463.378-.844.833-.844H29.24c.46 0 .832.375.832.844v4.19H1.712v-4.19zm28.36 27.684v5.517a.843.843 0 0 1-.832.844H2.545a.836.836 0 0 1-.833-.844V8.926h28.36v1.678h1.669V3.058A2.51 2.51 0 0 0 29.24.535H2.545c-.293 0-.57.061-.833.156A2.52 2.52 0 0 0 .044 3.058v33.201a2.51 2.51 0 0 0 2.501 2.522H29.24c1.079 0 1.998-.702 2.346-1.678.094-.265.155-.547.155-.844v-5.517h-1.669zm3.092-12.34a.842.842 0 0 1 0 1.186l-3.092 3.108-1.083 1.088a.83.83 0 0 1-1.18 0l-2.497-2.509a.843.843 0 0 1 0-1.186.831.831 0 0 1 1.18-.002l1.907 1.918.005-.005 1.668-1.677 1.913-1.921a.831.831 0 0 1 1.18 0zm1.794 5.727a6.685 6.685 0 0 1-4.766 3.181 6.624 6.624 0 0 1-.953.076c-.326 0-.642-.03-.953-.076-3.233-.466-5.72-3.258-5.72-6.636a6.707 6.707 0 0 1 5.72-6.636c.31-.045.627-.077.953-.077.324 0 .642.032.953.077a6.677 6.677 0 0 1 4.766 3.179 6.7 6.7 0 0 1 .953 3.457 6.701 6.701 0 0 1-.953 3.455zm1.096 1.375a8.367 8.367 0 0 0 1.525-4.83 8.383 8.383 0 0 0-2.78-6.245 8.28 8.28 0 0 0-6.488-2.09 8.287 8.287 0 0 0-1.854.433c-.355.128-.703.27-1.034.443a8.385 8.385 0 0 0-4.31 5.593 8.436 8.436 0 0 0-.216 1.866c0 4.319 3.245 7.87 7.414 8.336.3.033.603.053.91.054a8.282 8.282 0 0 0 5.735-2.29l3.07 3.087a.832.832 0 0 0 1.18 0 .845.845 0 0 0 0-1.187l-3.152-3.17z"/>
                <path d="M20.477 14.108a.926.926 0 0 1-.924.928H5.4a.926.926 0 0 1-.923-.928c0-.513.413-.929.923-.929h14.153c.51 0 .924.416.924.929M18.015 19.68a.926.926 0 0 1-.923.928H5.4a.926.926 0 0 1-.923-.929c0-.512.413-.928.923-.928h11.692c.51 0 .923.416.923.928M18.63 25.25a.926.926 0 0 1-.923.93H5.4a.926.926 0 0 1-.923-.93c0-.512.413-.928.923-.928h12.307c.51 0 .923.416.923.929M22.938 31.441a.926.926 0 0 1-.923.929H5.4a.926.926 0 0 1-.923-.929c0-.513.413-.929.923-.929h16.615c.51 0 .923.416.923.929"/>
            </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'pictogram-03'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 40 36">
          <path :fill="iconColor" fill-rule="evenodd" d="M8.952 4.783c0-.477.385-.864.858-.864.474 0 .86.387.86.864a.862.862 0 0 1-.86.864.862.862 0 0 1-.858-.864zm-2.577 0c0-.477.386-.864.86-.864s.857.387.857.864a.861.861 0 0 1-.858.864.862.862 0 0 1-.859-.864zm-1.717.864a.862.862 0 0 1-.86-.864c0-.477.386-.864.86-.864s.858.387.858.864a.862.862 0 0 1-.858.864zm28.34 10.366a.863.863 0 1 1 0-1.727.863.863 0 0 1 0 1.727zm0-3.455a2.587 2.587 0 0 0-2.576 2.591c0 .406.1.784.267 1.124-.032.031-.07.051-.095.086l-4.5 6.037-3.6-4.344a.855.855 0 0 0-1.375.073l-4.571 6.898-3.554-3.574a.854.854 0 0 0-1.259.05l-5.153 6.046a.866.866 0 0 0 .094 1.218c.36.31.901.268 1.21-.094l4.549-5.338 3.639 3.659a.855.855 0 0 0 1.32-.131l4.516-6.812 3.558 4.294a.856.856 0 0 0 1.347-.035l5.086-6.82c.334.158.702.255 1.097.255a2.587 2.587 0 0 0 2.577-2.592 2.587 2.587 0 0 0-2.577-2.59zm5.152 20.734a.864.864 0 0 1-.858.862H2.941a.86.86 0 0 1-.86-.862V9.102H38.15v24.19zM2.081 3.053c0-.472.389-.86.86-.86h34.352c.474 0 .857.384.857.86v4.321H2.081v-4.32zM37.292.463H2.941c-.303 0-.59.063-.86.16a2.588 2.588 0 0 0-1.717 2.43v30.239a2.582 2.582 0 0 0 2.577 2.59h34.351a2.588 2.588 0 0 0 2.577-2.59V3.053a2.584 2.584 0 0 0-2.577-2.59z"/>
      </svg>
    </template>
    <template v-else-if="iconName === 'arrow-left'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-469.000000, -1126.000000)">
              <g id="arrow-left" transform="translate(481.000000, 1138.000000) rotate(-270.000000) translate(-481.000000, -1138.000000) translate(469.000000, 1126.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon id="Triangle" :fill="iconColor" points="12 15 7 9 17 9"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'arrow-right'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-603.000000, -1126.000000)">
              <g id="arrow-right" transform="translate(615.000000, 1138.000000) rotate(-90.000000) translate(-615.000000, -1138.000000) translate(603.000000, 1126.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon id="Triangle" :fill="iconColor" points="12 15 7 9 17 9"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'arrow-up'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-737.000000, -1126.000000)">
              <g id="arrow-up" transform="translate(749.000000, 1138.000000) rotate(-180.000000) translate(-749.000000, -1138.000000) translate(737.000000, 1126.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon id="Triangle" :fill="iconColor" points="12 15 7 9 17 9"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'arrow-down'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-871.000000, -1126.000000)">
              <g id="arrow-down" transform="translate(871.000000, 1126.000000)">
                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                  <polygon id="Triangle" :fill="iconColor" points="12 15 7 9 17 9"></polygon>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'descending-sort'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1139.000000, -1126.000000)">
            <g id="descending-sort" transform="translate(1151.000000, 1138.000000) rotate(-180.000000) translate(-1151.000000, -1138.000000) translate(1139.000000, 1126.000000)">
                <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                <g id="Group-2" transform="translate(7.000000, 6.000000)" :fill="iconColor">
                    <polygon id="chevron-up" points="4.99899295 0 0.109549533 4.64753706 1.53452436 6 4.99899295 2.70588235 8.47949219 6 9.90446701 4.64753706"></polygon>
                    <rect id="Rectangle-5" x="4" y="2" width="2" height="10"></rect>
                </g>
            </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'ascending-sort'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-1273.000000, -1126.000000)">
            <g id="ascending-sort" transform="translate(1273.000000, 1126.000000)">
                <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                <g id="Group-2" transform="translate(7.000000, 6.000000)" :fill="iconColor">
                    <polygon id="chevron-up" points="4.99899295 0 0.109549533 4.64753706 1.53452436 6 4.99899295 2.70588235 8.47949219 6 9.90446701 4.64753706"></polygon>
                    <rect id="Rectangle-5" x="4" y="2" width="2" height="10"></rect>
                </g>
            </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'user'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="MGTB_-library-(product)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Iconography" transform="translate(-334.000000, -1337.000000)">
                  <g id="user" transform="translate(334.000000, 1337.000000)">
                      <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                      <g id="Group-15" transform="translate(6.000000, 4.000000)" :fill="iconColor">
                          <path d="M10.2873826,3.65868263 C10.2873826,5.67932635 8.64930479,7.31736527 6.6287,7.31736527 C4.60805629,7.31736527 2.97001737,5.67932635 2.97001737,3.65868263 C2.97001737,1.63803892 4.60805629,0 6.6287,0 C8.64930479,0 10.2873826,1.63803892 10.2873826,3.65868263" id="user-1"></path>
                          <path d="M0,14.9071856 L12.9740425,14.9071856 L12.9740389,12.1047904 C12.9740389,12.1047904 12.9999611,8.23853593 8.66664072,8.31638024 C8.66664072,8.31638024 7.0059491,9.32598204 4.38520359,8.31521257 C4.38520359,8.31521257 0.44110479,7.95311976 0,12.1307515 L0,14.9071856 Z" id="user-3"></path>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'link'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
          <g id="MGTB_-library-(product)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Iconography" transform="translate(-473.000000, -1340.000000)">
                  <g id="link" transform="translate(469.000000, 1336.000000)">
                      <rect id="Rectangle-3" opacity="0.25" x="0" y="0" width="24" height="24"></rect>
                      <path d="M11.1151588,9 L11.1151588,10.4641217 L12.5221792,10.4641217 C13.3294319,10.4641217 13.5476287,10.7396805 13.5476287,11.4896324 L13.5476287,17.4614731 C13.5476287,18.242936 13.4004195,18.4869838 12.5221792,18.4869838 L6.55089444,18.4869838 C5.71779588,18.4869838 5.52544494,18.3062257 5.52544494,17.4614731 L5.52544494,11.4896324 C5.52544494,10.6973448 5.75371731,10.4641217 6.55089444,10.4641217 L7.87276035,10.4641217 L7.87276035,9 L6.03900659,9 C4.91470149,9 4,9.91469587 4,11.0390616 L4,17.9609384 C4,19.0853041 4.91470149,20 6.03900659,20 L12.9609934,20 C14.0852985,20 15,19.0853041 15,17.9609384 L15,11.0390616 C15,9.91469587 14.0852985,9 12.9609934,9 L11.1151588,9 Z" id="link-1" :fill="iconColor"></path>
                      <path d="M16.1151588,4 L16.1151588,5.46412165 L17.5221792,5.46412165 C18.3294319,5.46412165 18.5476287,5.73968054 18.5476287,6.48963242 L18.5476287,12.4614731 C18.5476287,13.242936 18.4004195,13.4869838 17.5221792,13.4869838 L11.5508944,13.4869838 C10.7177959,13.4869838 10.5254449,13.3062257 10.5254449,12.4614731 L10.5254449,6.48963242 C10.5254449,5.69734483 10.7537173,5.46412165 11.5508944,5.46412165 L12.8727604,5.46412165 L12.8727604,4 L11.0390066,4 C9.91470149,4 9,4.91469587 9,6.03906164 L9,12.9609384 C9,14.0853041 9.91470149,15 11.0390066,15 L17.9609934,15 C19.0852985,15 20,14.0853041 20,12.9609384 L20,6.03906164 C20,4.91469587 19.0852985,4 17.9609934,4 L16.1151588,4 Z" id="link-1" :fill="iconColor" transform="translate(14.500000, 9.500000) rotate(-180.000000) translate(-14.500000, -9.500000) "></path>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'list'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
        <g id="Iconography" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="1">
            <g id="list" transform="translate(-250.000000, -308.000000)">
                <g id="list" transform="translate(250.000000, 308.000000)">
                    <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                    <g id="Group-4" transform="translate(6.000000, 7.000000)" :fill="iconColor">
                        <polygon id="minus" points="0 2 12 2 12 0 0 0"></polygon>
                        <polygon id="minus-copy-3" points="0 6 12 6 12 4 0 4"></polygon>
                        <polygon id="minus-copy-4" points="0 10 12 10 12 8 0 8"></polygon>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'save'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24">
        <g id="화면개선-201807" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="1">
            <g id="데모-통합리포트-주석수정/삭제" transform="translate(-1170.000000, -743.000000)">
                <g id="Group-6-Copy" transform="translate(232.000000, 727.000000)">
                    <g id="save" transform="translate(938.000000, 16.000000)">
                        <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                        <path d="M5,4 L5,19 L19,19 L19,8.07065217 L14.7389783,4 L5,4 Z M7.68206522,8.56506522 L11.2581522,8.56506522 L11.2581522,6.28245652 L7.68206522,6.28245652 L7.68206522,8.56506522 Z M7.68206522,16.9090169 L16.3179348,16.9090169 L16.3179348,10.5434783 L7.68206522,10.5434783 L7.68206522,16.9090169 Z" id="Fill-1" :fill="iconColor"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
    </template>
    <template v-else-if="iconName === 'folder'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="folder-g" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="folder-g2" transform="translate(-20.000000, -568.000000)">
                  <g id="menu" transform="translate(0.000000, 1.000000)">
                      <g id="folder-g3" transform="translate(0.000000, 554.000000)">
                          <g id="menu1_d">
                              <g id="folder-g4" transform="translate(20.000000, 13.000000)">
                                  <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                                  <g transform="translate(4.000000, 4.000000)" :fill="iconColor">
                                      <rect id="Rectangle-11" x="0" y="3" width="16" height="11"></rect>
                                      <polygon id="Rectangle-11-Copy" points="0 0.401692708 7.05577528 0.401692708 11.8847656 8 0 8"></polygon>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'enter'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="채널추가" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="채널관리&gt;리포트-관리" transform="translate(-73.000000, -527.000000)">
                  <g id="Card-1-Copy-5" transform="translate(50.000000, 299.000000)">
                      <g id="enter" transform="translate(23.000000, 228.000000)">
                          <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                          <g id="download" transform="translate(11.500000, 11.500000) rotate(-90.000000) translate(-11.500000, -11.500000) translate(3.000000, 3.000000)" :fill="iconColor">
                              <polygon id="Fill-1" points="11.9916551 3 11.9916551 5.18589135 14.006 5.18589135 14.006 14.8852981 2 14.8852981 2 5.18589135 3.97773906 5.18589135 3.97773906 3 6.82121026e-13 3 0.005 16.8852981 16.005 16.8852981 16.006 3"></polygon>
                              <polygon id="Fill-2" points="6.99676786 0 6.99676786 9.31329584 4.79776786 7.11429584 3.38376786 8.52829584 8.03176786 13.1752958 12.6707679 8.53729584 11.2567679 7.12329584 8.99776786 9.38229584 8.99776786 0"></polygon>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </template>
    <template v-else-if="iconName === 'calendar'">
      <svg :width="iconWidth + 'px'" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="채널추가" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="채널관리&gt;리포트-관리" transform="translate(-73.000000, -527.000000)">
                  <g id="Card-1-Copy-5" transform="translate(50.000000, 299.000000)">
                      <g id="enter" transform="translate(23.000000, 228.000000)">
                          <rect id="Rectangle-4" stroke-opacity="0.01" stroke="#FFFFFF" style="mix-blend-mode: multiply;" x="0.5" y="0.5" width="23" height="23"></rect>
                          <g id="calendar" fill="none" fill-rule="evenodd" opacity=".8">
                            <path stroke="#FFF" stroke-opacity=".01" d="M.5.5h23v23H.5z" style="mix-blend-mode:multiply"/>
                            <path fill="#485464" d="M15.429 5H8.57V3H6v2H4v16h16V5h-2V3h-2.571v2zM6 19.071V9h12v10.071H6zM12.567 13v4H16.5v-4h-3.933z"/>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </template>
  </div>
</template>

<script>
export default {
  name: 'mt-icon',
  props: {
    color: {
			type: String,
			default: null
    },
    iconName: {
			type: String,
			default: 'dashboard'
    },
    width: {
      type: Number,
      default: 24
    },
    hover: {
      type: [Boolean, String],
      default: 'not-set'
    },
  },
  components: {

  },
  inject: {
      buttonStatus: {
        default: null
      }
  },
  data () {
    return {
      defaultColor: '#485465',
      isHover: false,
      defaultWidth: 24,
    }
  },

  computed: {
    iconColor() {
      let color = this.defaultColor
      if(this.color) color = this.color
      if(this.buttonStatus && this.buttonStatus.color) color = this.buttonStatus.color
      if(this.iconHover) color =  this.colorHover
      return color
    },
    iconWidth() {
      if(this.width) return this.width
      if(this.buttonStatus) return this.buttonStatus.size == 'small' ? 24 : 27.4
      return this.defaultWidth
    },
    iconHover() {
      if(typeof this.hover === 'boolean') return this.hover
      if(this.buttonStatus) return this.buttonStatus.hover
      return this.isHover
    },
    colorHover() {
      let color = '#485465'
      if(this.buttonStatus) color = this.buttonStatus.hoverColor
      return color
    },
    classes() {
      let classes = ''
      if(this.iconColor === this.defaultColor) classes += ' defaultColor'
      if(this.iconHover) classes += ' hover'
      return classes + ' mt-icon--' + this.iconName
    }
  },

  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    }
  },


}
</script>


<style src="./Icon.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Icon.vue?58c58daa